export default (state, settings = {}) => ({ settings });
